import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const routes: RouteRecordRaw = {
  path: '',
  name: 'FinancialManagement',
  redirect: '/index',
  component: Layout,
  meta: {
    title: '财务协同',
    icon: 'financial-management|svg'
  },
  children: [
    {
      path: 'invoice-management',
      name: 'InvoiceManagement',
      component: () => import('@/views/InvoiceManagement/InvoiceManagement.vue'),
      meta: {
        title: '发票管理',
        module: 'INVOICE_MANAGEMENT',
        hidePageHeader: true
      }
    },
    {
      path: 'invoice-management/upload',
      name: 'InvoiceUpload',
      component: () => import('@/views/InvoiceManagement/invoice-upload/invoice-upload.vue'),
      meta: {
        title: '上传发票',
        parentMenu: '/invoice-management'
      }
    },
    {
      path: 'invoice-management/detail',
      name: 'InvoiceDetail',
      component: () => import('@/views/InvoiceManagement/invoice-detail/invoice-detail.vue'),
      meta: {
        title: '发票详情',
        parentMenu: '/invoice-management'
      }
    },
    {
      path: 'bill-management',
      name: 'BillManagement',
      component: () => import('@/views/BillManagement/bill-management.vue'),
      meta: {
        title: '账单管理',
        module: 'BILL_MANAGEMENT'
      }
    },
    // 账单管理页面跳转发票上传页面，复用发票上传页面
    {
      path: 'bill-management/upload',
      name: 'InvoiceUploadFromBillManagement',
      component: () => import('@/views/InvoiceManagement/invoice-upload/invoice-upload.vue'),
      meta: {
        title: '上传发票',
        parentMenu: '/bill-management'
      }
    },
    {
      path: 'bill-management/detail',
      name: 'BillDetail',
      component: () => import('@/views/BillManagement/bill-detail/index.vue'),
      meta: {
        title: '账单详情',
        parentMenu: '/bill-management'
      }
    },
    {
      path: 'bill-management/list',
      name: 'BillList',
      component: () => import('@/views/BillManagement/bill-list/index.vue'),
      meta: {
        title: '账单明细',
        parentMenu: '/bill-management',
        hidePageHeader: true
      }
    },
    {
      path: 'bill-management/apply-payment',
      name: 'ApplyPaymentFromBillManagement',
      component: () =>
        import('@/views/BillManagement/apply-payment/apply-payment-from-bill-management.vue'),
      meta: {
        title: '申请付款',
        parentMenu: '/bill-management',
        hidePageHeader: true
      }
    },
    {
      path: 'async-download',
      name: 'AsyncDownload',
      component: () => import('@/views/AsyncDownload/async-download.vue'),
      meta: {
        title: '下载列表',
        module: 'ASYNC_DOWNLOAD'
      }
    },
    {
      path: 'payment-management',
      name: 'PaymentManagement',
      component: () => import('@/views/PaymentManagement/list/apply-payment-list.vue'),
      meta: {
        title: '付款申请管理',
        module: 'PAYMENT_MANAGEMENT'
      }
    },
    {
      path: 'payment-management/apply',
      name: 'ApplyPayment',
      component: () => import('@/views/PaymentManagement/apply-payment/apply-payment.vue'),
      meta: {
        title: '重新申请付款',
        parentMenu: '/payment-management',
        hidePageHeader: true
      }
    },
    {
      path: 'payment-management/detail',
      name: 'ApplyPaymentDetail',
      component: () => import('@/views/PaymentManagement/detail/apply-payment-detail.vue'),
      meta: {
        title: '详情',
        parentMenu: '/payment-management'
      }
    }
  ]
}
export default routes
